import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Role } from '@feathr/blackbox';
import Page from '@feathr/extender/App/Page';
import { useAccount, useUser } from '@feathr/extender/state';

import AttributionOptions from './AttributionOptions';
import ConversionsOptions from './ConversionsOptions';

function ConversionsPage(): JSX.Element {
  const user = useUser();
  const account = useAccount();
  const { t } = useTranslation();

  const isFeathrAdmin = user.isSudoer;
  const isAdmin =
    isFeathrAdmin || account.get('acl').find((i) => i.user_id === user.id)?.role === Role.admin;

  return (
    <Page title={t('Conversions')}>
      {t('Manage settings related to tracking conversions.')}
      {isAdmin && <ConversionsOptions account={account} />}
      <AttributionOptions account={account} />
    </Page>
  );
}

export default observer(ConversionsPage);
